import { EVENTS } from './Events'
import ReactGA from 'react-ga'
import GoogleAnalytics from './Vendors/GoogleAnalytics'
// import AWSFirehose from './Vendors/Firehose';

class Tracker {
  constructor (userData) {
    // for testing purposes
    const industries = ['health', 'finance', 'entertainment']
    this.hostname = window && window.location && window.location.hostname ? window.location.hostname : ''
    this.EVENTS = EVENTS
    this.user = userData || { industry: industries[Math.floor(Math.random() * industries.length)] }
    this.reactGA = ReactGA

    switch (this.hostname) {
      case 'qa-app.postured.io':
        this.TRACKING_ID = 'UA-122865200-2' // qa site tracking ID
        break
      case 'localhost':
        this.TRACKING_ID = 'UA-122865200-5' // localhost site tracking ID
        break
      case 'app.postured.io':
        this.TRACKING_ID = 'UA-122865200-4' // prod site tracking ID
        break
      default:
        // console.log(`No tracking id available for hostname ${this.hostname}`)
        this.TRACKING_ID = ''
    }

    this.reactGA.initialize(this.TRACKING_ID, {
      debug: false
    })

    const GA = new GoogleAnalytics(this.reactGA, this.hostname, this.user)
    // const Firehose = new AWSFirehose(this.reactGA, this.hostname, this.user);
    this.vendors = [GA]
  }

  /**
   *
   * @param {String} type The type of event that was detected
   * @param {Object} data The event data
   */
  handleEvent (type, data) {
    this.vendors.forEach(vendor => {
      vendor.handleEvent(type, data)
    })
  }
}

export default Tracker



// WEBPACK FOOTER //
// ./src/analytics/Tracker.js